<template>
  <div>
    <loading-state :state="state"></loading-state>
    <div v-if="credits && credits.grouped">
      <div class="title-and-tools">
        <div class="tools">
          <button class="clean full symbol-btn" @click="isMiniView = !isMiniView">↕</button>
        </div>
        <h2>Fantasy Player Credits</h2>
      </div>
      <div
        class="page-space"
        v-if="isOrderedView">
        <div class="boxes keep-left">
          <div 
            class="box filled min-width"
            v-for="playerKey in credits.playerKeys" :key="playerKey">
            <match-player-credits
            :playerKey="playerKey"
            :credits="credits"
            :isMiniView="isMiniView"
            @playerSelected="onPlayerSelected"
            ></match-player-credits>
          </div>
        </div>
      </div>
      <div v-else>
        <div
          class="page-space"
          v-for="role in credits.grouped"
          v-if="role.players.length"
          :key="role.name">
          <h5 class="bottom-space">{{role.name}}</h5>
          <div class="boxes keep-left">
            <div 
              class="box filled min-width"
              v-for="playerKey in role.players" :key="playerKey">
              <match-player-credits
              :playerKey="playerKey"
              :teamName="credits.teams[credits.players[playerKey].teamKey].code"
              :credits="credits"
              :isMiniView="isMiniView"
              @playerSelected="onPlayerSelected"
              ></match-player-credits>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="points">
      <div class="title-and-tools">
        <div class="tools">
          <button class="clean full symbol-btn" @click="isMiniView = !isMiniView">↕</button>
        </div>
        <h2>Fantasy Player Points</h2>
      </div>
      
      <div
        class="page-space"
        v-for="role in points.grouped"
        v-if="role.players.length"
        :key="role.name">
        <h5 class="bottom-space">{{role.name}}</h5>

        <div class="boxes keep-left">
          <div 
            class="box filled min-width"
            v-for="playerKey in role.players" :key="playerKey"
            v-if="points.players[playerKey].fantasyPoints.breakup.length"
            >
            <div>
              <div 
                class="clickable head"
                @click="onPlayerSelected(playerKey)">{{points.players[playerKey].name}}</div>
              <div class="boxes compact width30 big-numbers">
                <div><div class="highlight">{{points.players[playerKey].fantasyPoints.points | locale('-')}}</div><label>points</label></div>
                <div><div>{{points.players[playerKey].fantasyPoints.season_points | locale('-')}}</div><label>Season</label></div>
              </div>
              <template v-if="(!isMiniView) && points.players[playerKey].fantasyPoints.breakup.length" >
                <div class="sub-head">Breakup</div>
                <div class="boxes compact width30">
                  <ul class="silent small">
                    <li v-for="(parts, index) in points.players[playerKey].fantasyPoints.breakup" :key="index">
                      <b class="info">{{parts[1] | locale('-')}}</b> - {{points.fantasyMetrics[parts[0]]}}
                    </li>
                    <li v-if="points.players[playerKey].fantasyPoints.points_by_match_role"><b class="info">{{points.players[playerKey].fantasyPoints.points_by_match_role}}</b> - Points by match role</li>
                  </ul>
                </div>
<!-- 
                <div class="foot" alt="Last updated Match Time">
                  <small>{{points.players[playerKey].fantasyPoints.lastUpdated | simpleDateTimeString}}</small>
                </div> -->
              </template>
            </div>
          </div>
        </div>

      </div>
    </div>
    <div v-if="state.isLoaded() && !(credits || points)">
      Fantasy information not available
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import AppEvents from '@/appevents'
import MatchPlayerCredits from '@/components/football/MatchPlayerCredits'

export default {
  components: {
    'MatchPlayerCredits': MatchPlayerCredits
  },
  props: {
    match: Object,
  },
  data () {
    return {
      credits: null,
      points: null,
      isMiniView: false,
      isOrderedView: false,
      state: DataState.newLoading(),
    }
  },
  created () {
    this.$globalEvents.$on(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  beforeDestroy () {
    this.$globalEvents.$off(AppEvents.cricketMatchUpdate, this.onMatchUpdated)
  },
  watch: {
    'match.key' (to, from) {
      if (this.match.key !== this.match.key) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },
  mounted () {
    this.onViewOpenned()
  },
  methods: {
    onViewOpenned (useFresh) {
      if(this.match.info.status.isNotStarted) {
        this.match.fantasyCredits(useFresh).then(credits => {
          this.credits = credits
          this.points = null
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      } else {
        this.match.fantasyPoints(useFresh).then(points => {
          this.credits = null
          this.points = points
          this.state.changeToLoaded()
        }).catch((error) => {
          console.error(error)
          this.state.changeToError(error)
        })
      }
    },
    onMatchUpdated (match) {
      if(!this.state.isLoaded()) {return}
      this.onViewOpenned(true)
    },
    prepareToReopen () {
      this.credits = null
      this.points = null
    },
    refreshView () {

    },
    onPlayerSelected (playerKey) {
      this.$emit('playerSelected', playerKey)
    }
  }
}
</script>
